import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        snapshot: {},
        positive_arbitrages: {},
        finished_transfers: [],
        packageVersion: process.env.PACKAGE_VERSION || '0',
        api_url: process.env.VUE_APP_LOCAL_API_URL,
        refCount: 0,
        isLoading: false,
        refCountDown: 0,
        isLoadingDown: false,
        token: localStorage.getItem("token") || "",
        user: localStorage.getItem("user") || "{}",
        admin: localStorage.getItem("admin") || false,
        search: "",
        update_key: 0,
        printing: false,
    },
    mutations: {
        loading(state, isLoading) {
            if (isLoading) {
                state.refCount++;
                state.isLoading = true;
            } else if (state.refCount > 0) {
                state.refCount--;
                state.isLoading = state.refCount > 0;
            }
        },
        loading_down(state, isLoadingDown) {
            if (isLoadingDown) {
                state.refCountDown++;
                state.isLoadingDown = true;
            } else if (state.refCountDown > 0) {
                state.refCountDown--;
                state.isLoadingDown = state.refCount > 0;
            }
        },
        auth_success(state, data) {
            state.status = 'success';
            state.token = data["token"];
            state.admin = data["admin"];
        },
        add_user(state, data) {
            state.status = 'success'
            state.user = JSON.stringify(data["user"])
            localStorage.setItem('user', state.user)
        },
        logout(state) {
            state.status = 'fail'
            state.user = ''
            state.token = ''
            state.admin = false
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('admin')
        },
        interact_dialog(state, data) {
            state.dialogs[data.key] = data.value
        },
        set_language(state, lang) {
            state.current_language = lang
        },
        toggle_printing(state) {
            state.printing = !state.printing
        }
    },
    actions: {
        login({
            commit
        }, user) {

            return new Promise((resolve, reject) => {
                axios({
                    url: this.getters.api_url + 'auth/login/',
                    data: user,
                    method: 'POST'
                })
                    .then(resp => {
                        const token = resp.data.Authorization
                        const user = resp.data.User
                        const admin = resp.data.admin
                        localStorage.setItem('token', token)
                        localStorage.setItem('admin', admin)
                        commit('auth_success', {
                            "token": token,
                            "admin": admin
                        })
                        const header = {
                            headers: {
                                Authorization: localStorage.getItem('token')
                            }
                        }
                        axios.get(this.state.api_url + 'user/profile/' + user, header).then((response) => {
                            commit('add_user', {
                                "user": response.data
                            })
                            resolve(resp)
                        })

                    })
                    .catch(err => {
                        console.log(err)
                        if (err.response.status != "fail") {
                            reject(err)
                        }
                    })
            })
        },
        logout({
            commit
        }) {
            return new Promise((resolve, reject) => {
                const header = {
                    Authorization: localStorage.getItem('token')
                }

                axios({
                    url: this.getters.api_url + 'auth/logout/',
                    data: {},
                    method: 'POST',
                    headers: header
                })
                    .then(resp => {
                        commit('logout')
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err)
                        commit('logout')
                        reject(err)
                    })

            })
        }
    },
    modules: {},
    getters: {
        getTokenWatch: (state) => (state.token),
        isLoggedIn: state => (state.token != ""),
        logged_user: state => {
            if (state.user != "") {
                return JSON.parse(state.user)
            } else {
                return {}
            }
        },
        user: state => {
            if (state.user != "") {
                return JSON.parse(state.user)
            } else {
                return {}
            }
        },
        is_admin: state => (state.admin != "false"),
        api_url: state => (state.api_url),
        appVersion: (state) => (state.packageVersion),
        update_key: (state) => (state.update_key),
        header: state => {
            const header = {
                headers: {
                    Authorization: state.token
                }
            }
            return header
        }
    }
})
